import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Typography, Grid, Container } from '@mui/material';
import ServiceTable from '../components/ServiceTable';
import AnimatedSection from '../components/AnimatedSection';
const skin_hair = '/assets/skin-hair-hero.jpeg';


const sections = [
  {
    title: 'Stretch Marks Reduction',
    rows: [
      { service: 'Stretch Marks Reduction (Per Session)', price: '₹3,000' },
      { service: 'Stretch Marks Reduction (Package of 6)', price: '₹15,000' },
    ],
  },
  {
    title: 'Tattoo',
    rows: [
      { service: 'Small Tattoo', price: '₹500 onwards' },
      { service: 'Medium Tattoo', price: '₹2,000 onwards' },
      { service: 'Large Tattoo', price: '₹5,000 onwards' },
    ],
  },
  {
    title: 'Body Whitening Treatments',
    rows: [
      { service: 'Face Whitening', price: '₹2,500' },
      { service: 'Full Body Whitening', price: '₹8,000' },
      { service: 'Underarm Whitening', price: '₹1,500' },
      { service: 'Neck & Back Whitening', price: '₹3,000' },
    ],
  },
  {
    title: 'Piercing',
    rows: [
      { service: 'Ear Lobe', price: '₹500' },
      { service: 'Nose', price: '₹500' },
      { service: 'Cartilage', price: '₹800' },
      { service: 'Belly Button', price: '₹1,000' },
    ],
  },
  {
    title: 'Medical Facials',
    rows: [
      { service: 'Acne Treatment Facial', price: '₹3,000' },
      { service: 'Pigmentation Facial', price: '₹3,500' },
      { service: 'Anti-Ageing Medical Facial', price: '₹4,000' },
      { service: 'Skin Rejuvenation Facial', price: '₹5,000' },
      { service: 'Chemical Peel', price: '₹3,500' },
      { service: 'Micro Dermabrasion', price: '₹4,000' },
    ],
  },
  {
    title: 'Nail Extensions',
    rows: [
      { service: 'Basic Nail Extensions', price: '₹2,000' },
      { service: 'Gel Nail Extensions', price: '₹3,000' },
      { service: 'Acrylic Nail Extensions', price: '₹3,500' },
      { service: 'Nail Art (per nail)', price: '₹200' },
      { service: 'Nail Removal', price: '₹500' },
    ],
  },
  {
    title: 'Permanent Hair Removal',
    rows: [
      { service: 'Upper Lip (Per Session)', price: '₹1,500' },
      { service: 'Chin (Per Session)', price: '₹1,500' },
      { service: 'Full Face (Per Session)', price: '₹4,000' },
      { service: 'Under Arms (Per Session)', price: '₹3,000' },
      { service: 'Full Arms (Per Session)', price: '₹6,000' },
      { service: 'Full Legs (Per Session)', price: '₹8,000' },
      { service: 'Full Body (Per Session)', price: '₹15,000' },
      { service: 'Bikini (Per Session)', price: '₹5,000' },
    ],
  },
  {
    title: 'Fish Pedicure',
    rows: [
      { service: 'Fish Pedicure (30 Min)', price: '₹1,500' },
      { service: 'Fish Pedicure (60 Min)', price: '₹2,500' },
    ],
  },
];

export default function SkinHairPage() {
  return (
    <Box>
      <Helmet>
        <title>Skin Treatments & Facials in Vizag | Splash Beauty Lounge</title>
        <meta name="description" content="Experience advanced facials, detan, acne treatment and skincare services at Splash Beauty Lounge in Vizag." />
        <meta name="keywords" content="facials Vizag, skin treatments Vizag, detan services Vizag, acne treatment Vizag, skincare  clinic Vizag, glow facial Vizag" />
      </Helmet>
      {/* Hero */}
      <Box
        sx={{
          position: 'relative',
          backgroundImage: `url(${skin_hair})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          py: { xs: 8, md: 12 },
          textAlign: 'center',
          color: '#fff',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          },
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          <Typography
            variant="h2"
            sx={{
              color: '#fff',
              fontFamily: '"Playfair Display", serif',
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              mb: 1.5,
              textShadow: '0 2px 10px rgba(0,0,0,0.3)',
            }}
          >
            Skin & Hair Treatments
          </Typography>
          <Typography
            sx={{
              fontFamily: '"Lato", sans-serif',
              color: 'rgba(255,255,255,0.9)',
              fontSize: '1.1rem',
              maxWidth: '600px',
              mx: 'auto',
              px: 2,
            }}
          >
            Advanced clinical treatments for skin rejuvenation, hair removal & more
          </Typography>
        </Box>
      </Box>

      <Container maxWidth="lg" sx={{ py: 7 }}>
        <Grid container spacing={4}>
          {sections.map((section, i) => (
            <Grid item xs={12} md={6} key={section.title}>
              <AnimatedSection delay={(i % 4) * 0.1}>
                <Box sx={{ mb: 1 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontFamily: '"Playfair Display", serif',
                      color: '#FF0099',
                      mb: 1.5,
                      fontSize: '1.2rem',
                    }}
                  >
                    {section.title}
                  </Typography>
                  <ServiceTable rows={section.rows} />
                </Box>
              </AnimatedSection>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}